import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Clock, CheckCircle } from 'lucide-react';
import { portalApi } from '../../contexts/PortalAuthContext';

export default function PortalModules() {
  const [modules, setModules] = useState([]);

  useEffect(() => {
    portalApi.get('/modules').then(({ data }) => setModules(data)).catch(() => {});
  }, []);

  return (
    <div data-testid="portal-modules-list">
      <header className="mb-8">
        <div className="text-amber-400 text-xs uppercase tracking-widest mb-2">Curriculum</div>
        <h1 className="text-3xl font-semibold text-white">All modules</h1>
        <p className="text-slate-400 mt-2">Work through them in order, or jump to whatever you need to revisit.</p>
      </header>

      <div className="space-y-3">
        {modules.map(m => {
          const tasks = m.progress?.tasks_total || 0;
          const done = m.progress?.tasks_completed || 0;
          const pct = tasks ? Math.round(100 * done / tasks) : 0;
          return (
            <Link
              key={m.id}
              to={`/portal/modules/${m.id}`}
              className="block rounded-xl border border-slate-800 bg-slate-900/60 hover:border-amber-500/40 p-5 transition"
              data-testid={`portal-module-row-${m.number}`}
            >
              <div className="flex items-start gap-5">
                <div className="text-3xl font-bold text-slate-700 w-12 shrink-0">
                  {String(m.number).padStart(2, '0')}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-start justify-between gap-3">
                    <h3 className="text-white font-semibold leading-snug">{m.title}</h3>
                    {m.progress?.module_completed && (
                      <span className="text-xs text-emerald-400 flex items-center gap-1 shrink-0">
                        <CheckCircle className="w-3.5 h-3.5" /> Done
                      </span>
                    )}
                  </div>
                  {m.subtitle && <p className="text-sm text-slate-400 mt-1">{m.subtitle}</p>}
                  <div className="flex items-center justify-between mt-3 text-xs text-slate-500">
                    <span className="flex items-center gap-1.5"><Clock className="w-3.5 h-3.5" /> {m.duration_minutes || 45} min</span>
                    <span>{done}/{tasks} tasks · {pct}%</span>
                  </div>
                  <div className="mt-2 h-1 bg-slate-800 rounded-full overflow-hidden">
                    <div className="h-full bg-amber-500" style={{ width: `${pct}%` }} />
                  </div>
                </div>
              </div>
            </Link>
          );
        })}
        {modules.length === 0 && (
          <div className="text-slate-500 text-sm">No modules published yet.</div>
        )}
      </div>
    </div>
  );
}
